import React, { Component } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { Listbox, ListboxItem } from '@heroui/react';
import breakpointsMinWidth from '../../../../cra/src/styling/breakpointsMinWidth';

const Dropdown = styled.div`
  /* TODO: to use this dropdown on click instead of hover use clickEvent prop */
  display: ${(props) => (props.clickEvent ? 'block' : 'none')};

  position: absolute;
  left: ${(props) => (props.left ? `${props.left}px` : null)};
  top: ${(props) => (props.top ? `${props.top}px` : null)};
  border-radius: 4px;
  box-shadow: 0px 2px 10px 2px rgba(41, 49, 89, 0.16);
  background: white;

  &.profile {
    @media screen and (max-width: 768px) {
      display: ${(props) => !props.pathname.includes('/documents/') && 'none'};
    }
  }

  &.notification {
    right: 0;
    top: 48px;
    z-index: 3;

    &:hover {
      display: block;
    }
  }

  &.comment {
    z-index: 3;
    top: 48px;
  }

  &.driveContext {
    z-index: 3;
  }

  &.resumeDropdown {
    top: 75%;
    @media ${breakpointsMinWidth.desktopMd} {
      top: 75%;
    }
  }

  &.fileDropdown {
    top: 70%;

    @media ${breakpointsMinWidth.desktopMd} {
      top: 75%;
    }
  }
`;

const StyledListItme = styled(ListboxItem)`
  text-decoration: none;
  background-color: red !important;
`;

const StyledListBox = styled(Listbox)`
  ul {
    padding: 4px !important;

    a {
      text-decoration: none !important;
      text-align: left !important;
      color: #000 !important;
      display: grid !important;
      grid-template-columns: 20px 1fr !important;
    }
  }
`;

class DropDown extends Component {
  state = {};

  componentDidMount = () => {
    const { handleCloseDropdown, className } = this.props;
    document.addEventListener('mousedown', (e) => {
      handleCloseDropdown(e, className);
    });
  };

  componentWillUnmount = () => {
    const { handleCloseDropdown } = this.props;
    document.removeEventListener('mousedown', handleCloseDropdown);
  };

  render() {
    const {
      left,
      top,
      childrenList,
      className,
      pathname,
      clickEvent,
      appType,
    } = this.props;

    return (
      <Dropdown
        clickEvent={clickEvent}
        left={left}
        top={top}
        className={className}
        pathname={pathname}
        appType={appType}
      >
        <StyledListBox
          aria-label="Listbox menu with descriptions"
          variant="flat"
          classNames={{
            list: '!p-0 m-0 list-none [&>*:last-child]:!m-0 !bg-[red]',
            base: '!p-0 !bg-[red]',
          }}
        >
          {childrenList.map((item) => (
            <StyledListItme
              key={item.url}
              href={item.url}
              as="a"
              description={item?.description}
              startContent={item?.icon}
            >
              {item.text}
            </StyledListItme>
          ))}
        </StyledListBox>
        {/* {LinkComponent && (
          <CustomMenu
            handleCloseDropdown={handleCloseDropdown}
            childrenList={childrenList}
            parentMenuClassName={parentMenuClassName}
            markRead={(nodeId, indexData) => markRead(nodeId, indexData)}
            approveDeny={approveDeny}
            labelKey={labelKey}
            sendVerificationEmail={(indexData) =>
              sendVerificationEmail(indexData)
            }
            handleComment={handleComment}
            menuItemClassName={className}
            appType={appType}
            LinkComponent={LinkComponent}
          />
        )} */}
      </Dropdown>
    );
  }
}

DropDown.propTypes = {
  handleCloseDropdown: propTypes.func,
  left: propTypes.number,
  className: propTypes.string,
  top: propTypes.number,
  childrenList: propTypes.arrayOf(propTypes.object),
  pathname: propTypes.string,
};

DropDown.defaultProps = {
  handleCloseDropdown: () => {},
  left: 0,
  className: '',
  top: 0,
  childrenList: [{}],
  pathname: '',
};

export default DropDown;
